import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ability from '@/libs/acl/ability'

export default function useLeaveCodesList() {

    //User toast
    const toast = useToast()

    const refLeaveCodeListTable = ref(null)

    const tableColumns = [
        {key: 'leave_code', sortable: true},
        {key: 'description'},
        {key: 'remark'},
        {key: 'count_al_balance', label:'COUNT AL BALANCE', sortable: true},
        {key: 'reason_bit', label:'Require Reason', sortable: true},
        {key: 'action'}
    ]

    const perPage = ref(10)
    const totalLeaveCodes = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('id')
    const isSortDirDesc = ref(true)

    const dataMeta = computed(() => {
        const localItemsCount = refLeaveCodeListTable.value ? refLeaveCodeListTable.value.localItems.length : 0
        return {
            from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
            to: perPage.value * (currentPage.value - 1) + localItemsCount,
            of: totalLeaveCodes.value,
        }
    })

    const refetchData = () => {
        refLeaveCodeListTable.value.refresh()
    }

    watch([currentPage, perPage, searchQuery], () => {
        refetchData()
    })

    const fetchLeaveCodes = (ctx, callback) => {
        store.dispatch('setting-leavecode/fetchLeaveCodes',{
            q: searchQuery.value,
            perPage: perPage.value,
            page: currentPage.value,
            sortBy: sortBy.value,
            sortDesc: isSortDirDesc.value,
        })
        .then(response =>{
            const {leavecodes, total} = response.data
            callback(leavecodes)
            totalLeaveCodes.value = total
        
        })
        .catch((error) => {
            toast({
                component: ToastificationContent,
                props: {
                    title: 'Error fetching leave codes list',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger'
                }
            })
        })
    }

    return {
        fetchLeaveCodes,
        tableColumns,
        perPage,
        currentPage,
        totalLeaveCodes,
        dataMeta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        refLeaveCodeListTable,
        ability,
        refetchData
    }

}